<template>
  <div id="errorPopup" v-if="isShow">
    <div class="modal">
      <div class="black_bg"></div>
      <div class="popup_cont">
        <div class="text">
          <p>
            <template v-if="errorInfo.errorCode != null"
              >[오류코드 : {{ errorInfo.errorCode }}]<br
            /></template>
            {{ errorInfo.errorTime }}
          </p>
          <span>
            {{ errorInfo.errorMessage }}
          </span>
        </div>
        <div class="button">
          <button @click="closeErrorPopup" class="ok">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "BaseErrorPopup",
  setup() {
    const isShow = ref(false);
    const errorInfo = ref({});
    const callBackFunc = ref();

    const openErrorPopup = (errorData) => {
      isShow.value = true;
      errorInfo.value = errorData;
      callBackFunc.value = errorData.callBackFunc;
    };

    const closeErrorPopup = () => {
      isShow.value = false;
      if (callBackFunc.value) {
        callBackFunc.value();
        callBackFunc.value = undefined;
      }
    };

    return {
      openErrorPopup,
      closeErrorPopup,
      errorInfo,
      isShow,
    };
  },
};
</script>

<style></style>
